<div *transloco="let t">
	<h1 id="sh-cookie-dialog-title-h1" mat-dialog-title>{{ t('cloud.shared.cookie-dialog.cookies-are-required') }}</h1>
	<div id="sh-cookie-dialog-description-div">
		{{ t('cloud.shared.cookie-dialog.cookies-are-disabled-description') }}
	</div>
</div>
